<template>
  <div id="tjcloud" :class="{'bg2':!loginShow}">
    <div class="login-title" v-show="loginShow">
      <img :src="logo" alt="" class="login-logo">
      <p class="divider">工业智慧运维平台</p>
      <!-- <el-divider content-position="center">工业智慧运维平台</el-divider> -->
    </div>
    <!-- 登录 -->
    <div class="login-box" v-show="loginShow">
      <div class="tab clearfix">
          <p class="f-l" @click="activeName = 0" :class="{'active-lab':activeName==0}">账号密码登录</p>
          <p class="f-r" @click="activeName = 1" :class="{'active-lab':activeName==1}">手机验证码登录</p>
      </div>
      <div v-show="activeName==0">
        <el-form :model="ruleForm" :rules="rules" ref="passForm" :inline="true">
          <el-form-item prop="account" autocomplete="off">
              <div class="account"><!--  :class="[{'err-active':errAccountShow},'account',{'keydown':keydown=='account'}]" -->
                  <span class="label"><img :src="icon1" class="icon"></span>
                  <el-input v-model="ruleForm.account" id="username" placeholder="请输入用户id或手机号" @keyup.enter.native="passLogin('passForm')" @focus="keydown='account'" @blur="keydown=''"></el-input>
              </div>
          </el-form-item>
          <el-form-item prop="password" autocomplete="off" class="m-b-12">
              <div class="password"> <!-- :class="[{'err-active':errPassShow},'password',{'keydown':keydown=='password'}]" -->
                  <span class="label"><img :src="icon2" class="icon"></span>
                  <el-input v-model="ruleForm.password" id="password" show-password placeholder="请输入密码" @keyup.enter.native="passLogin('passForm')" @focus="keydown='password'" @blur="keydown=''"></el-input>
              </div>
          </el-form-item>
        </el-form>
        <p class="wjmm" @click="operate('forgotShow')">忘记密码？</p>
        <div class="login-btn" @click="passLogin('passForm')" id="login1">登录</div>
      </div>
      <div v-show="activeName==1">
        <el-form :model="ruleForm" :rules="rules" ref="verifyCodeForm" :inline="true">
          <el-form-item prop="mobile" autocomplete="off">
              <div class="account"><!--  :class="[{'err-active':errAccountShow},'account',{'keydown':keydown=='account'}]" -->
                  <span class="label"><img :src="icon3" class="icon"></span>
                  <el-input v-model="ruleForm.mobile" id="mobile" placeholder="请输入手机号" @keyup.enter.native="verifyLogin('verifyCodeForm')" @focus="keydown='account'" @blur="keydown=''"></el-input>
              </div>
          </el-form-item>
          <el-form-item prop="verifyCode" autocomplete="off" class="m-b-12">
              <div class="password"> <!-- :class="[{'err-active':errPassShow},'password',{'keydown':keydown=='password'}]" -->
                  <span class="label"><img :src="icon2" class="icon"></span>
                  <el-input v-model="ruleForm.verifyCode" id="verifyCode" placeholder="请输入验证码" @keyup.enter.native="verifyLogin('verifyCodeForm')" @focus="keydown='password'" @blur="keydown=''"></el-input>
              </div>
          </el-form-item>
          <div class="code-box">
              <p class="get-code2" v-show="getCodeShow" @click.stop="getCode('verifyCodeForm')" id="getCode" >{{timerTxt}}</p>
              <p class="countdown" v-show="countdownShow">{{second}}S 后重新获取</p>
          </div>
        </el-form>
        <div class="login-btn" @click="verifyLogin('verifyCodeForm')" id="login2">登录</div>
      </div>
    </div>
    <!-- 忘记密码 -->
    <div v-show="forgotShow">
      <div class="forgot-pass">
          <p class="first-top">找回密码 <span class="toLogin" @click="toLogin">返回</span></p>
          <el-form :model="ruleForm" :rules="rules" ref="forgotForm" class="clearfix m-t-84 w-367">
              <el-form-item prop="mobile" autocomplete="off" class="m-t-22" >
                  <div class="account border-b" :class="{'keydown':keydown=='mobile3'}">
                      <span class="label">手机号</span>
                      <el-input v-model="ruleForm.mobile" id="mobile3" @focus="keydown='mobile3'" @blur="keydown=''" placeholder="请输入手机号" @input="ruleForm.mobile=ruleForm.mobile.replace(/[^\d]/g,'')" maxlength="11"></el-input>
                  </div>
              </el-form-item>
              <el-form-item prop="verifyCode" autocomplete="off" class="m-b-12">
                  <div class="password border-b" :class="{'keydown':keydown=='verifyCode3'}">
                      <span class="label">验证码</span>
                      <el-input v-model="ruleForm.verifyCode" @focus="keydown='verifyCode3'" @blur="keydown=''"  id="verifyCode3" placeholder="请输入验证码" class="w-212"></el-input>
                      <div class="code-box">
                          <p class="get-code" v-show="getCodeShow" @click.stop="getCode('forgotForm')" id="getCode12" >{{timerTxt}}</p>
                          <p class="countdown" v-show="countdownShow">{{second}}S 后重新获取</p>
                      </div>
                  </div>
              </el-form-item>
              <el-button type="primary" class="login-btn m-t-84" @click="forgotPass('forgotForm')" id="forgotPass">确认</el-button>
          </el-form>
      </div>
    </div>
    <!-- 重置密码 -->
    <div class="reset-pass" v-show="resetShow">
        <div class="forgot-pass">
            <p class="first-top">修改密码 <span class="toLogin" @click="toLogin">返回</span></p>
            <el-form :model="ruleForm" :rules="rules" ref="resetForm" class="clearfix m-t-84">
                <el-form-item prop="newPass" autocomplete="off" class="m-b-12" >
                    <div class="account w-90 border-b" :class="{'keydown':keydown=='newPass3'}">
                        <span class="label w-125">请输入新密码</span>
                        <el-input v-model="ruleForm.newPass" id="newPass3" @focus="keydown='newPass3'" @blur="keydown=''" show-password placeholder="请输入8位密码，其中包含大小写字母，数字"></el-input>
                    </div>
                </el-form-item>
                <el-form-item prop="confirmPass" autocomplete="off" class="m-b-12" >
                    <div class="account w-90 border-b" :class="{'keydown':keydown=='confirmPass3'}">
                        <span class="label w-125">请确认新密码</span>
                        <el-input v-model="ruleForm.confirmPass" id="confirmPass3" @focus="keydown='confirmPass3'" @blur="keydown=''" show-password placeholder="请输入8位密码，其中包含大小写字母，数字"></el-input>
                    </div>
                </el-form-item>
                <el-button type="primary" class="login-btn m-t-84" @click="resetPass('resetForm')" id="resetPass">确认</el-button>
            </el-form>
        </div>
        <!-- <p class="bq">深圳市xxxx网络科技有限公司版权所有</p> -->
    </div>
    <!-- 首次登录 -->
    <div class="first-box" v-show="firstLoginShow">
        <div class="forgot-pass">
            <p class="first-top">首次登录</p></p>
            <el-form :model="ruleForm" :rules="rules" ref="firstForm" class="clearfix m-t-84">
                <el-form-item prop="newPass" autocomplete="off" class="m-b-12" >
                    <div class="account w-90 border-b" :class="{'keydown':keydown=='newPass'}">
                        <span class="label w-125">请输入新密码</span>
                        <el-input v-model="ruleForm.newPass" id="newPass" @focus="keydown='newPass'" @blur="keydown=''" show-password  @keyup.enter.native="firstLogin('firstForm')" placeholder="请输入8位密码，其中包含大小写字母，数字"></el-input>
                    </div>
                </el-form-item>
                <el-form-item prop="confirmPass" autocomplete="off" class="m-b-12" >
                    <div class="account w-90 border-b" :class="{'keydown':keydown=='confirmPass'}">
                        <span class="label w-125">请确认新密码</span>
                        <el-input v-model="ruleForm.confirmPass" id="confirmPass" @focus="keydown='confirmPass'" @blur="keydown=''" show-password  @keyup.enter.native="firstLogin('firstForm')" placeholder="请输入8位密码，其中包含大小写字母，数字"></el-input>
                    </div>
                </el-form-item>
                <el-form-item prop="mobile" autocomplete="off" class="m-b-12">
                    <div class="account border-b" :class="{'keydown':keydown=='mobile2'}">
                        <span class="label">手机号</span>
                        <el-input v-model="ruleForm.mobile" id="phone" @focus="keydown='mobile2'" @blur="keydown=''" @keyup.enter.native="firstLogin('firstForm')" placeholder="请输入手机号" @input="ruleForm.mobile=ruleForm.mobile.replace(/[^\d]/g,'')" maxlength="11"></el-input>
                    </div>
                </el-form-item>
                <el-form-item prop="verifyCode" autocomplete="off" class="m-b-12">
                    <div class="password border-b" :class="{'keydown':keydown=='verifyCode2'}">
                        <span class="label">验证码</span>
                        <el-input v-model="ruleForm.verifyCode" id="verifyCode2" @focus="keydown='verifyCode2'" @blur="keydown=''" placeholder="请输入验证码"class="w-212"  @keyup.enter.native="firstLogin('firstForm')"></el-input>
                        <div class="code-box">
                            <p class="get-code" v-show="getCodeShow" @click.stop="getCode('firstForm')" id="getCode2" >{{timerTxt}}</p>
                            <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
                        </div>
                    </div>
                </el-form-item>
                <el-button type="primary" class="login-btn m-t-22" @click="firstLogin('firstForm')" id="firstLogin">确认</el-button>
            </el-form>
        </div>
        <!-- <p class="bq">深圳市xxxx网络科技有限公司版权所有</p> -->
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      var validatePhone = (rule, value, callback) =>{
        let reg=/^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
        if(value == "" || value == null){
          callback(new Error('手机号不能为空'));
        }else if(!reg.test(value)){
          callback(new Error('请输入正确的手机号码'));
        }else{
          callback();
        }
      }
      var verifyCode = (rule, value, callback) =>{
        if(value == "" || value == null){
          callback(new Error('验证码不能为空'));
        }else if(value.length != 4){
          callback(new Error('请输入4位验证码'));
        }else{
          callback();
        }
      }
      var validatePass = (rule, value, callback) =>{
          let reg =  /^(?=.*[A-Za-z])(?=.*\d)[^]{8,16}$/;
          if(value == "" || value == null){
              callback(new Error('新密码不能为空'));
          }else if(!reg.test(value)){
              callback(new Error('密码必须为8~16位，同时包含英文和数字'));
              // this.ruleForm.newPass = '';
          }else{
              callback();
          }
      }
      var valiConfirmPass = (rule, value, callback) =>{
          if(value == "" || value == null){
              callback(new Error('确认密码不能为空'));
          }else if(value != this.ruleForm.newPass){
              callback(new Error('确认密码与新密码不一致'));
              this.ruleForm.confirmPass = "";
          }else{
              callback();
          }
      }
      return {
        activeName:0,
        icon1:require('@/assets/image/TJCloudLogin/account.png'),
        icon2:require('@/assets/image/TJCloudLogin/pass.png'),
        icon3:require('@/assets/image/TJCloudLogin/phone.png'),
        logo:require('@/assets/image/header/logo.png'),
        loginShow:true,
        forgotShow:false,
        resetShow:false,
        firstLoginShow:false,
        passToken:null,
        ruleForm:{
          account:null,
          password:null,
          newPass:null,
          confirmPass:null,
          mobile:null,
          verifyCode:null,
        },
        rules:{
          account:[{required: true, message: "账号不能为空", trigger: 'blur'}],
          password:[{required: true, message: "密码不能为空", trigger: 'blur'}],
          mobile:[{required: true, validator: validatePhone, trigger: 'blur'}],
          verifyCode:[{required: true, validator: verifyCode, trigger: 'blur'}],
          newPass:[{validator: validatePass, trigger: 'blur'}],
          confirmPass:[{validator: valiConfirmPass, trigger: 'blur'}]
        },
        second:60,          //定时器
        getCodeShow:true,
        countdownShow:false,
        timer:null,
        timerTxt:"获取验证码",
        errShow:false,
        errText:'',
        keydown:'',
        link:null,
        title:null,
      }
    },
    created() {
        this.link=require('@/assets/image/index/favicon'+this.cssType+'.png')
        this.title = this.cssType==0?'捷云物联':'天机云平台'
        document.title = this.title; // 动态修改网站标题
        this.changeIco()
        this.$store.state.isLook = false
        localStorage.setItem('isLook',false)
    },
    methods:{
      // 密码登录
      passLogin(name){
          this.$refs[name].validate((valid) => {
              this.errShow = false
              if(valid){
                  let parm = {
                      userName:this.ruleForm.account,
                      password:this.ruleForm.password,
                      requestId:1,
                  }
                  this.post('/UserProfile/login',parm).then((res)=>{
                      if(res.success){
                          localStorage.setItem("loginState",true);
                          this.$store.state.userData=res.result
                          localStorage.setItem('userData',JSON.stringify(res.result))
                          // var cookieData=this.getCookie('SESSION'); //cookie赋值给变量。
                          // console.log(cookieData)
                          if(sessionStorage.getItem('routerNext')){
                          	let router = sessionStorage.getItem('routerNext');
                              sessionStorage.removeItem('routerNext')
                              if(router=='/login'||router=='/'){
                                  router = '/Overviews'
                              }
                          	this.$router.push({path:router});
                          }else{
                          	this.$router.push({path:"/Overviews"});
                          }
                      }else{
                          this.loginState(res.result,res.message);
                      }
                  })
              }
          })
      },
      //获取验证码
      getCode(name){
          this.$refs[name].validateField("mobile",(err) => {
              if(err==''){
                  let parm = {mobile:this.ruleForm.mobile}
                  if(name == 'firstForm'){
                      parm.firstBind="first"
                  }
                  this.post('/UserProfile/sendVerifyCode',parm).then((res)=>{
                      if(res.success){
                          this.getCodeShow=false;
                          this.countdownShow=true;
                          this.$message({
                              message: '验证码发送成功',
                              type: 'success'
                          });
                          const TIME_COUNT = 60;
                          if (!this.timer) {
                              this.second = TIME_COUNT;
                              this.timer = setInterval(() => {
                                  if (this.second > 0 && this.second <= TIME_COUNT) {
                                      this.second--;
                                  }else{
                                      this.getCodeShow = true;
                                      this.countdownShow=false;
                                      this.timerTxt = '再次获取'
                                      clearInterval(this.timer);
                                      this.timer = null;
                                  }
                              }, 1000)
                          }
                      }else{
                          this.$message({
                              message: `验证码发送失败：${res.message}`,
                              type: 'warning'
                          });
                      }
                  })
              }
          })
      },
      //验证码登录
      verifyLogin(name){
          this.$refs[name].validate((valid) => {
              this.errShow = false
              if(valid){
                  let parm = {
                      mobile:this.ruleForm.mobile,
                      verifyCode:this.ruleForm.verifyCode
                  }
                  this.post('/UserProfile/loginByVerifyCode',parm).then((res)=>{
                      if(res.success){
                          localStorage.setItem("loginState",true);
                          this.$store.state.userData=res.result
                          localStorage.setItem('userData',JSON.stringify(res.result))
                          if(sessionStorage.getItem('routerNext')){
                            let router = sessionStorage.getItem('routerNext');
                              if(router=='/login'||router=='/'){
                                  router = '/Overviews'
                              }
                            sessionStorage.removeItem('routerNext')
                            this.$router.push({path:router});
                          }else{
                            this.$router.push({path:"/Overviews"});
                          }
                      }else{
                          this.loginState(res.result,res.message);
                      }
                  })
              }
          })
      },
      //登录状态码管理
      loginState(state,errtext){
          // console.log(state,errtext)
          // this.errAccountShow=false
          // this.errPassShow=false;
          let showAlert = true
          switch (state){
            case 1111:
                // this.errShow=false;
                this.firstLoginShow = true;
                this.loginShow = false;
                this.ruleForm = this.$options.data().ruleForm;
                showAlert=false
                break;
            case 4003:
                this.activeName = 1;
                this.errtext="只能使用验证码登录,您输入的密码错误次数已达到3/3次数";
                break;
            case 4005:
                this.firstLoginShow = true;
                this.loginShow = false;
                this.ruleForm = this.$options.data().ruleForm;
                showAlert=false
                break;
            default:
                this.errtext = errtext;
                break;
          }
          if(showAlert){
            this.$message({
              type:'warning',
              message:this.errtext
            })
          }
      },
      // 去登陆
      toLogin(){
          this.ruleForm = this.$options.data().ruleForm
          this.loginShow=true;
          this.forgotShow = false;
          this.resetShow = false;
      },
      //忘记密码
      forgotPass(name){
          this.$refs[name].validate((valid) => {
              if(valid){
                  let parm = {
                      mobile:this.ruleForm.mobile,
                      verifyCode:this.ruleForm.verifyCode
                  }
                  this.post('/UserProfile/forgotPassword',parm).then((res)=>{
                      // console.log(parm,res)
                      if(res.success){
                          this.ruleForm = this.$options.data().ruleForm;
                          this.resetShow=true;
                          this.forgotShow = false
                          this.getCodeShow = true;
                          this.countdownShow=false;
                          this.timerTxt = '获取验证码';
                          clearInterval(this.timer);
                          this.passToken = res.result;
                          this.timer=null;
                      }else{
                          this.$message({
                              type:'warning',
                              message:res.message
                          })
                      }
                  })
              }
          })
      },
      //打开弹窗
      operate(name){
          this[name]=true;
          this.timerTxt="获取验证码";
          this.getCodeShow = true;
          this.countdownShow=false;
          clearInterval(this.timer);
          this.timer = null;
          if(name=='forgotShow'){
              this.loginShow=false;
          }
      },
      //重置密码
      resetPass(name){
          this.$refs[name].validate((valid) => {
              if(valid){
                  let parm = {
                      token:this.passToken,
                      password:this.ruleForm.newPass
                  }
                  this.post('/UserProfile/resetPassword',parm).then((res)=>{
                      if(res.success){
                          this.$message({
                              message: '重置成功，请重新登录',
                              type: 'success'
                          });
                          this.ruleForm = this.$options.data().ruleForm;
                          this.passToken = '';
                          this.resetShow = false;
                          this.loginShow = true;
                      }else{
                          this.$message({
                              message: `重置失败: ${res.message}`,
                              type: 'warning'
                          });
                      }
                  })
              }
          })
      },
      //首次登录
      firstLogin(name){
          this.$refs[name].validate((valid) => {
              if(valid){
                  let parm = {
                      newPassword:this.ruleForm.newPass,
                      mobile:this.ruleForm.mobile,
                      verifyCode:this.ruleForm.verifyCode
                  }
                  this.post('/UserProfile/bindMobile',parm).then((res)=>{
                      // console.log(parm,res)
                      if(res.success){
                          localStorage.setItem("loginState",true);
                          this.$store.state.userData=res.result;
                          localStorage.setItem('userData',JSON.stringify(res.result))
                          this.getCodeShow = true;
                          this.countdownShow=false;
                          this.timerTxt = '获取验证码';
                          clearInterval(this.timer);
                          this.timer = null;
                          this.ruleForm = this.$options.data().ruleForm;
                          if(sessionStorage.getItem('routerNext')){
                          	let router = sessionStorage.getItem('routerNext');
                              if(router=='/login'||router=='/'){
                                  router = '/Overviews'
                              }
                          	sessionStorage.removeItem('routerNext')
                          	this.$router.push({path:router});
                          }else{
                          	this.$router.push({path:"/Overviews"});
                          }
                      }else{
                          this.$message({
                              message: `绑定失败: ${res.message}`,
                              type: 'warning'
                          });
                      }
                  })
              }
          })
      },
      // 修改标题和图标
      changeIco(){
          let $favicon = document.querySelector('link[rel="icon"]');
          if ($favicon !== null) {
              $favicon.href = this.link;
          } else {
              $favicon = document.createElement("link");
              $favicon.rel = "icon";
              $favicon.href = this.link;
              document.head.appendChild($favicon);
          }
      },
    }
  }
</script>

<style scoped>
  #tjcloud{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    min-height: 786px;
    min-width:1336px ;
    background: url(../assets/image/TJCloudLogin/bg.png) no-repeat;
    background-size: 100% 100%;
  }
  .bg2{
    background: url(../assets/image/TJCloudLogin/bg2.png) no-repeat !important;
    background-size: 100% 100% !important;
  }
  .login-box{
    width: 51.7%;
    /* height: 18.5%; */
    padding-top: 25px;
    /* border: 1px solid #007EFF; */
    position: absolute;
    top: 50.5%;
    left: 23.5%;
    margin-top: -33px;
  }
  .tab{
      width: 315px;
      margin: 0 auto;
      margin-bottom: 35px;
      text-align: center;
      /* font-weight: 600; */
  }
  .tab>p{
      font-size: 18px;
      color: #d7e8ea;
      height: 18px;
      width: 49%;
      line-height: 18px;
      cursor: pointer;
  }
  .active-lab{
    color: #fff !important;
    font-weight: 600;
  }
  .tab>p:first-child{
      border-right: 2px solid #fff;
  }
  .account, .password{
    /* width: 48%; */
    padding-left: 50px;
    display: inline-block;
    position: relative;
  }
  .label{
    width: 48px;
    position: absolute;
    left: 0;
    background-color: #fcfcfc;
    /* border-radius: 5px; */
  }
  .icon{
    width: 22px;
    position: relative;
    top: 5px;
  }
  .wjmm{
    float: right;
    margin-right: 5%;
    font-size: 14px;
    color:  #fff;
    cursor: pointer;
    margin-top: -10px;
  }
  .login-btn{
    line-height: 40px;
    width: 80px;
    border: 2px solid #fff;
    border-radius: 5px;
    margin: 60px auto;
    color: #fff;
    font-size: 15px;
    cursor: pointer;
  }
  /* 倒计时 */
  .code-box {
    /* float: right; */
    display: inline-block;
    width: 110px;
    line-height: 40px;
    text-align: center;
    /* margin-right: 25px; */
    /* color: #fff; */
  }
  .get-code2{
    background-color: #fff;
    /* border-radius: 5px; */
    cursor: pointer;
  }
  .countdown{
    background-color: #c2c2c2;
    border-radius: 5px;
    color: #fff;
    cursor: not-allowed;
  }
  .login-title{
    margin-top: 200px;
  }
  .divider{
    margin-top: 32px;
    font-size: 22px;
    color: #fff;
    position: relative;
  }
  .divider::after{
    content: "";
    display: block;
    height: 2px;
    background-color: #fff;
    width: 15%;
    right:28%;
    top: 14px;
    position: absolute;
  }
  .divider::before{
    content: "";
    display: block;
    height: 2px;
    background-color: #fff;
    width: 15%;
    left:28%;
    top: 14px;
    position: absolute;
  }
  .login-logo{
    width: 130px;
  }
  .forgot-pass{
    width: 484px;
    /* margin: 0 auto; */
    position: absolute;
    top:30% ;
    background-color: #fff;
    left: calc(50% - 242px);
    box-shadow: 0 0 5px 0 #555;
    border-radius: 5px;
    padding: 0 22px;
    box-sizing: border-box;
  }
  .first-top{
      font-size: 20px;
      line-height: 38px;
      /* background-color: #308ff0; */
      /* color: #fff; */
      text-align: center;
      position: relative;
      top: 26px;
  }
  .toLogin{
      float: left;
      /* margin-left: 18px; */
      font-size: 13px;
      cursor: pointer;
      position: absolute;
      color: #21833a;
      top: -28px;
      left: 0
  }
  .m-t-84{
    margin-top: 48px;
  }
  .border-b{
    border-bottom: 2px solid #ebeaed;
  }
  .forgot-pass .account:not(.w-90),.forgot-pass .password:not(.w-90){
    width: 88%;
    /* margin-bottom: 20px; */
    padding-bottom: 10px;
  }
  .forgot-pass .account,.forgot-pass .password{
    width: 90%;
    /* margin-bottom: 20px; */
    padding-bottom: 10px;
  }
  .keydown.border-b{
    border-color: #21833A;
  }
  .keydown.border-b .label{
    color: #21833A;
  }
  .forgot-pass .get-code{
    color: #fff;
  }
  .forgot-pass .countdown{
    color: #555;
  }
  .forgot-pass .code-box{
    float: right;
  }
  .forgot-pass .login-btn{
    margin:25px 0;
    box-sizing: border-box;
    line-height: 12px;
  }
  .m-t-22{
    margin-bottom: 32px;
  }
  .label.w-125{
    width: 95px;
  }
  .w-90 .el-input{
    width: 82%;
    margin-left: 15px;
  }
</style>
<style>
  #tjcloud .login-box .el-input__inner{
    border-radius: 0px !important;
    line-height: 40px !important;
    float: left;
  }
  #tjcloud .login-box .el-form-item__error{
    left: 50px !important;
  }
  #tjcloud .account .el-input__inner, .password .el-input__inner{
      border: 0 !important;
  }
  #tjcloud .password .w-212.el-input{
      width: 270px !important;
      display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/TJCloudLogin.vue